import parse from 'date-fns/parse';
import format from 'date-fns/format';
import isValid from 'date-fns/is_valid';
import addMinutes from 'date-fns/add_minutes';

export default function(datetime, template = 'MMMM D, YYYY - h:mm A [EDT]') {
  const parsed = parse(datetime);

  if (!isValid(parsed)) {
    console.error('invalid date:', datetime);
    return '';
  }

  const utcOffset = parsed.getTimezoneOffset();
  const isDST = utcOffset < new Date(2016, 1, 1).getTimezoneOffset();
  const edtOffset = isDST ? 240 : 300;
  const offsetDiff = utcOffset - edtOffset;
  let adjustedTime = parsed;
  if (offsetDiff) {
    adjustedTime = addMinutes(parsed, offsetDiff);
  }

  return template === 'raw'
    ? adjustedTime
    : `${format(adjustedTime, template)}`;
}
